import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const CTABanner = () => {
    return (
        <section
            data-testid="cta-banner"
            className="section-dark relative z-10 py-28 lg:py-40 overflow-hidden"
        >
            <div className="st-container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9 }}
                    className="max-w-4xl"
                >
                    <p className="eyebrow text-[var(--st-gold)] mb-6">07 — Let's begin</p>
                    <h2 className="font-serif text-5xl md:text-7xl lg:text-[9rem] leading-[0.92] tracking-tighter">
                        Have a brand<br />
                        <span className="italic text-[var(--st-gold)]">challenge?</span>
                    </h2>
                    <p className="mt-10 text-lg lg:text-xl leading-relaxed text-[#c8c5b3] max-w-2xl">
                        Whether you need a full identity, a strategic second opinion, or a
                        workshop for your team — we'd love to hear what you're working on.
                    </p>
                    <Link
                        to="/contact"
                        data-testid="cta-book-call"
                        className="btn-primary mt-12 bg-[var(--st-gold)] border-[var(--st-gold)] text-[var(--st-ink)] hover:bg-[var(--st-cream)] hover:border-[var(--st-cream)]"
                    >
                        Book a free call <ArrowUpRight size={16} />
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};

export default CTABanner;
